import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import {
  Checkbox,
  ICheckbox,
  IRadiobox,
  Radiobox,
} from "components/CheckRadiobox";
import { TitleH3 } from "components/generic";
import { AboutMeDiv, ExpirienceGrid, GenderGrid } from "./styles";
import { useContextHospi } from "../../../context/ContextHospi";
import { IInputHookOut, InputLabel } from "components/Input";
import MultiSelect, { ISelectMulti } from "components/MultiSelect";
import TextArea, { ITextArea } from "components/TextArea";

import { getLanguage, sortTop } from "utils/fetchMapInfo";
import { TLang } from "assets/data/isoNameLanguage";

export const AboutMeComponent: React.FC<{
  gender: Partial<IRadiobox>;
  study?: IInputHookOut;
  spokenLanguage: ISelectMulti;
  expirience?: Partial<ICheckbox>[];
  shortDescription: Partial<ITextArea>;
}> = ({ gender, study, spokenLanguage, expirience, shortDescription }) => {
  const { userStatus } = useContextHospi();
  const user = userStatus === "host" ? "host" : "student";
  const { t, i18n } = useTranslation(user);

  const [livedWithHost, livedAbroad, livedOwn, livedAny] = expirience ?? [];

  const propsMultiSelect: ISelectMulti = {
    ...spokenLanguage,
    items: sortTop(getLanguage(i18n.language.toUpperCase() as TLang), [
      "gb",
      "nl",
      "de",
    ]).filter((item) => !spokenLanguage.values?.includes(item.value as string)),
    selected: getLanguage(i18n.language.toUpperCase() as TLang).filter((item) =>
      spokenLanguage.values?.includes(item.value as string)
    ),
  };


  useEffect(() => {
    if (expirience && expirience[3]?.checked)
      expirience
        ?.slice(0, 3)
        .map((item) => item?.changeStatus && item?.changeStatus(false));
    // eslint-disable-next-line
  }, [livedAny?.checked]);

  useEffect(() => {
    expirience
      ?.slice(0, 3)
      .map((item) => item?.checked)
      .some((item) => item) &&
      expirience[3]?.changeStatus &&
      expirience[3]?.changeStatus(false);

    // eslint-disable-next-line
  }, [livedWithHost?.checked, livedAbroad?.checked, livedOwn?.checked]);

  return (
    <AboutMeDiv>
      <div>
        <TitleH3>{t(`${user}Profile.aboutMeInfo.form.gender.title`)}</TitleH3>
        <GenderGrid warn={spokenLanguage.required && !gender.selected?.length}>
          {["male", "female", "prefer_not_answer"].map((item, num) => (
            <Radiobox
              {...gender}
              value={item}
              title={t(
                `${user}Profile.aboutMeInfo.form.gender.itemRadio.${num}`,
                { returnObjects: true }
              )}
              key={item}
            />
          ))}
        </GenderGrid>
      </div>
      {user === "student" && study !== undefined && <InputLabel {...study} />}
      <MultiSelect {...propsMultiSelect} />
      {user === "student" && expirience && (
        <div>
          <TitleH3>
            {t(`${user}Profile.aboutMeInfo.form.experience.title`)}
          </TitleH3>
          <ExpirienceGrid>
            {expirience &&
              expirience.map((item, num) => (
                <Checkbox
                  {...item}
                  title={t(
                    `studentProfile.aboutMeInfo.form.experience.itemCheckbox.${num}`,
                    { returnObjects: true }
                  )}
                  key={num}
                />
              ))}
          </ExpirienceGrid>
        </div>
      )}
      <TextArea {...shortDescription} />
    </AboutMeDiv>
  );
};
